import { useState } from "react";

export default function Testimonials() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      name: "Nguyễn Minh Anh",
      role: "Học sinh lớp 12, HCV IMO 2023",
      content:
        "Học viện Olympic đã giúp em phát triển tư duy toán học một cách toàn diện. Các thầy cô không chỉ dạy kiến thức mà còn truyền cảm hứng học tập. Nhờ đó em đã đạt được Huy chương Vàng IMO.",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Happy%20Vietnamese%20high%20school%20student%20with%20medal%2C%20young%20person%20celebrating%20academic%20achievement%2C%20bright%20smile%20and%20confident%20expression%2C%20school%20uniform%20or%20formal%20attire%2C%20clean%20white%20background%20portrait&width=300&height=300&seq=student-1&orientation=squarish",
    },
    {
      name: "Trần Đức Minh",
      role: "Học sinh lớp 11, HCB IOI 2023",
      content:
        "Chương trình lập trình tại đây thực sự xuất sắc. Em đã học được rất nhiều thuật toán nâng cao và cách tư duy giải quyết vấn đề. Môi trường học tập rất tích cực và thúc đẩy em tiến bộ mỗi ngày.",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Confident%20Vietnamese%20male%20student%20with%20programming%20background%2C%20teenager%20with%20glasses%20and%20intelligent%20expression%2C%20modern%20casual%20attire%2C%20technology%20elements%20in%20background%2C%20clean%20white%20background%20portrait&width=300&height=300&seq=student-2&orientation=squarish",
    },
    {
      name: "Lê Thị Hương",
      role: "Học sinh lớp 10, HCV VMO 2022",
      content:
        "Em rất biết ơn các thầy cô tại Học viện. Họ đã giúp em từ một học sinh bình thường trở thành người đạt giải cao trong Olympic Toán. Phương pháp giảng dạy ở đây rất khoa học và hiệu quả.",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Bright%20Vietnamese%20female%20student%20with%20academic%20achievement%2C%20young%20woman%20with%20warm%20smile%20and%20studious%20appearance%2C%20school%20uniform%20or%20neat%20casual%20attire%2C%20mathematics%20symbols%20in%20background%2C%20clean%20white%20background%20portrait&width=300&height=300&seq=student-3&orientation=squarish",
    },
    {
      name: "Phạm Văn Nam",
      role: "Học sinh lớp 12, HCĐ APIO 2022",
      content:
        "Học viện không chỉ dạy kiến thức mà còn rèn luyện kỹ năng tư duy logic và giải quyết vấn đề. Em đã trưởng thành rất nhiều về mặt học thuật và cả tính cách sau thời gian học tại đây.",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Determined%20Vietnamese%20male%20student%20with%20bronze%20medal%2C%20serious%20and%20focused%20expression%2C%20neat%20appearance%20with%20academic%20setting%2C%20computer%20programming%20elements%20visible%2C%20clean%20white%20background%20portrait&width=300&height=300&seq=student-4&orientation=squarish",
    },
    {
      name: "Hoàng Thị Lan",
      role: "Cựu học sinh, hiện là SV ĐH Stanford",
      content:
        "Học viện Olympic đã đặt nền móng vững chắc cho sự nghiệp học thuật của em. Những kiến thức và kỹ năng học được ở đây giúp em thành công không chỉ trong các kỳ thi mà còn trong học tập đại học.",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Successful%20Vietnamese%20university%20student%20at%20Stanford%2C%20young%20woman%20with%20confident%20and%20mature%20appearance%2C%20graduation%20or%20university%20setting%2C%20professional%20attire%2C%20clean%20white%20background%20portrait&width=300&height=300&seq=student-5&orientation=squarish",
    },
    {
      name: "Đỗ Minh Quân",
      role: "Cựu học sinh, Software Engineer tại Google",
      content:
        "Những gì em học được tại Học viện Olympic không chỉ giúp em đạt thành tích cao trong học tập mà còn định hướng được con đường sự nghiệp. Em rất tự hào khi được là cựu học sinh của Học viện.",
      rating: 5,
      image:
        "https://readdy.ai/api/search-image?query=Professional%20Vietnamese%20software%20engineer%2C%20young%20man%20in%20business%20casual%20attire%20with%20confident%20smile%2C%20modern%20tech%20office%20background%20with%20Google%20branding%20elements%2C%20clean%20white%20background%20portrait&width=300&height=300&seq=student-6&orientation=squarish",
    },
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i
        key={index}
        className={`ri-star-${
          index < rating ? "fill" : "line"
        } text-yellow-400`}
      ></i>
    ));
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Học sinh nói gì về chúng tôi
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Những chia sẻ chân thành từ các học sinh và cựu học sinh của Học
              viện Olympic
            </p>
          </div>

          <div className="relative">
            <div className="overflow-hidden">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="w-full flex-shrink-0">
                    <div className="max-w-4xl mx-auto">
                      <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl p-8 md:p-12">
                        <div className="flex flex-col md:flex-row items-center gap-8">
                          <div className="flex-shrink-0">
                            <img
                              src={testimonial.image}
                              alt={testimonial.name}
                              className="w-32 h-32 rounded-full object-cover object-top shadow-lg"
                            />
                          </div>

                          <div className="flex-1 text-center md:text-left">
                            <div className="flex justify-center md:justify-start mb-4">
                              {renderStars(testimonial.rating)}
                            </div>

                            <blockquote className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6 italic">
                              "{testimonial.content}"
                            </blockquote>

                            <div>
                              <h4 className="text-xl font-bold text-gray-900 mb-1">
                                {testimonial.name}
                              </h4>
                              <p className="text-blue-600 font-semibold">
                                {testimonial.role}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl text-gray-600"></i>
            </button>

            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl text-gray-600"></i>
            </button>
          </div>

          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  index === currentSlide ? "bg-blue-600" : "bg-gray-300"
                }`}
              />
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl p-8 text-white text-center">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Bạn cũng muốn trở thành một phần của gia đình Olympic?
            </h3>
            <p className="text-blue-100 mb-6 text-lg">
              Hãy bắt đầu hành trình chinh phục đỉnh cao tri thức cùng chúng tôi
            </p>
            <button
              onClick={() => scrollToSection("contact")}
              className="bg-white text-blue-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              Đăng ký học thử miễn phí
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
